<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M4.22,14.9l8-8a1.11,1.11,0,1,0-1.56-1.57L0,16,10.66,26.68a1.1,1.1,0,0,0,1.56-1.56l-8-8H30.9a1.11,1.11,0,0,0,0-2.21Z"
    />
</svg>
